<template>
    <div class="container">
        <div class="con" v-for="(value, key) in list" :key="key">
            <div class="dataCon" :style="{ width: `calc(100% - ${index * 20}px)` }">
                <div class="data" @click="look(value)">
                    <a>账号：{{ value.loginname }}</a>
                    <a>手机号：{{ value.userphone }}</a>
                    <a>USDT：{{ value.money1 }}</a>
                    <!--                    <a>比例：{{value.bili}}</a>-->
                    <a>是否激活：{{ value.is_jihuo == 1 ? '是' : '否' }}</a>
                    <a>等级：L{{ value.level }}</a>
                </div>
                <div class="circle" @click="look(value)">
                    {{ value.is_xiaji == 1 ? `+` : `-` }}
                </div>
            </div>
            <treeDownList :list="value.child" :index="index + 1"></treeDownList>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            static_level
        }
    },
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
        index: {
            type: Number,
            default: 0
        }
    },
    filters: {
        levelFilter(level) {
            switch (level) {
                case '0':
                    return '普通会员'
                case '1':
                    return '1星会员'
                case '2':
                    return '2星会员'
                case '3':
                    return '3星会员'
                case '4':
                    return '合伙人'
            }
        }
    },
    methods: {
        look(value) {
            if (value.is_xiaji == 0) return
            User.UserTuandui({ id: value.userid }).then(res => {
                value.child =
                    value.child.length === 0
                        ? res.result.map(v => {
                              v.child = []
                              return v
                          })
                        : []
            })
        }
    }
}
</script>

<style scoped lang="less">
.container {
    > div.con {
        .dataCon {
            position: relative;
            float: right;
            border-radius: 8px;
            border: 1px solid #1890ff;
            margin-bottom: 10px;
            > div.data {
                padding: 13px 13px 13px 30px;
                a {
                    &:not(:last-child) {
                        margin-right: 10px;
                    }
                }
            }
            > div.circle {
                @size: 18px;
                width: @size;
                height: @size;
                position: absolute;
                z-index: 1;
                top: 50%;
                left: 5px;
                border: 1px solid #1890ff;
                border-radius: 100%;
                transform: translate(0, -50%);
                color: #1890ff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
